import { Flex, Heading, Text } from '@chakra-ui/react';

export const InventoryAllHeading = () => {
  return (
    <Flex gap={8} flexDirection="column" flexWrap="wrap">
      <Heading
        as="h1"
        color="text-dark.500"
        variant={{
          base: 'component-heading-large/xl',
          sm: 'component-heading-large/3xl',
          lg: 'component-heading-large/4xl',
        }}
        fontFamily="Biennale"
        maxW="80%"
      >
        Glossary of Software Development, Product & Startup Terms
      </Heading>
      <Text variant="component-text/md" color="text-dark.300">
        This resource is designed for startup founders, corporate legal teams, product managers, and developers alike.
        Here you&apos;ll find clear, concise definitions of the most essential terms in modern software development,
        digital product strategy, and emerging technologies. Whether you&apos;re reviewing a tech contract or planning
        your next sprint, this glossary helps you understand the language that drives the digital world.
      </Text>
    </Flex>
  );
};
